import { Box, Divider, Tab, Typography, styled } from "@mui/material";
import { IBasicTab, ICustomizedTab } from "./IBasicTab";
import { useEffect, useState } from "react";
import Tabs from '@mui/material/Tabs';
import "./basicTab.css";
import ListItem from "../card/listItem/listItem";
import CustomizedTab from "./customizedTab";
import { useQueryClient } from "react-query";
import { PAYMENT_ID } from "../../config/cacheKey";
import "./basicTab.css"



interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    maxHeight?: string | null;

}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, maxHeight } = props;



    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            className="tabpanel-container loan-details-tabpanel-container"
            style={{
                paddingInline: "5px", overflow: 'auto',
                position: 'inherit',
            }}

        >
            {value === index && <Box sx={{ paddingTop: "20px !important", paddingBottom: "20px !important", height: "100%" }}>{children}</Box>}
        </div>
    );
}


export default function BasicTab({ tabs, backgroundColor, dividerNeeded, width, selectedTab, setSelectedTab, maxHeight }: ICustomizedTab) {
    const StyledTab = styled(Tab)({
        '&.MuiTab-root': {
            color: "var(--tirnary-text-color) !important",
            borderBottom: "1px solid #D7DBEC",
            fontSize: "14px",
            paddingBottom: "8px",
        },
        '&.Mui-selected': {
            color: "#A8946E !important",
            alignItems: "center",
            fontSize: "14px",
            fontWeight: "bold",
            borderBottom: "1px solid #A8946E",

        },
        "& svg": {
            marginLeft: "5px",
        },

    });
    const queryClient = useQueryClient();
    let paymentId: number | undefined;
    paymentId = queryClient.getQueryData(PAYMENT_ID);
    const [value, setValue] = useState(paymentId ? paymentId : 0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {

        setValue(newValue);
        if (selectedTab != undefined) {
            setSelectedTab!(undefined);
        }
    };

    const renderTabsWithDividers = () => {
        let tabElements: React.ReactNode[] = [];


        tabs?.forEach((item: any, index: number) => {
            // Push each StyledTab into the array
            tabElements.push(
                <StyledTab
                    key={item.id}
                    icon={item.icon ? item.icon : <></>}
                    iconPosition="start"
                    label={item.title}
                    value={index}
                />
            );

            // Push Divider after each tab except the last one
            if (index < tabs?.length - 1) {
                tabElements.push(
                    <Divider
                        key={`divider-${index}`}
                        orientation="vertical"
                        flexItem
                        sx={{
                            margin: '20px 0px',
                            height: '30px',
                            color: "#707070",
                        }}
                    />
                );
            }
        });

        return tabElements;
    };

    useEffect(() => {
        if (selectedTab != undefined) {
            setValue(selectedTab)
        }
    }, [selectedTab])
    return (
        <>
            <Box sx={{ width: '100%', height: "100%" }}>
                <div style={{
                    backgroundColor: 'var(--bg-color)',
                    // width: '32rem',
                    // position: 'fixed',
                    zIndex: '100',
                    height: '5rem',
                    width: "100%",

                }}>


                    <Tabs value={value}

                        style={{
                            "backgroundColor": `${backgroundColor ? backgroundColor : ""}`, width: width ? tabs?.length > 1 ? '17rem' : '100%' : '100%',
                            // position: 'fixed',
                            zIndex: '1',
                            //  maxWidth: '549px'


                        }}

                        onChange={handleChange}
                        variant="fullWidth"
                        // textColor="#BBA57A"
                        // indicatorColor="#BBA57A"
                        aria-label="basic tabs example">
                        {(dividerNeeded != null && dividerNeeded == true) ?
                            renderTabsWithDividers()
                            :
                            tabs?.map((item: any, index: number) => (
                                <StyledTab icon={item.icon != null ? item.icon : <></>} iconPosition="start" label={item.title} key={item.id}></StyledTab>
                                // <CustomizedTab item={item} tabsCount={tabs.length} dividerNeeded={item.dividerNeeded}></CustomizedTab>

                            ))}

                    </Tabs>
                </div>
                {tabs?.length > 0 ? tabs?.map((item: IBasicTab) => (
                    <CustomTabPanel value={selectedTab != undefined ? selectedTab : value} index={item.id} children={item.child} maxHeight={maxHeight}></CustomTabPanel>
                )) :
                    <Box sx={{ background: "#fff", border: "1px solid #D7DBEC", borderRadius: "5px", width: "100%", height: "38vh", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "1rem" }}>
                        <img src='/images/dollor-notebook.png' alt='a coin with a notebook' />
                        <Typography sx={{ color: "var(--tirnary-text-color)", width: "fit-content", height: "fit-content" }}>قسط پرداخت شده ای ندارید</Typography>
                    </Box>
                }
            </Box >
        </>
    );
}